import Markdown from 'react-markdown';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

export let DesignatedFundLandingActivityFeed = function ({ keys, activityFeedComments }) {
    function getDateDisplayString(datestamp) {
        const date = new Date(Number(datestamp));
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }
    // Add state to your component to track if the list is expanded
    const [isExpanded, setIsExpanded] = useState(false);

    // Create a reversed copy of the array to start mapping from the end
    const reversedKeys = [...keys].reverse();

    // Slice the reversed array to show the first 3 items (originally the last 3)
    const displayedKeys = isExpanded ? reversedKeys : reversedKeys.slice(0, 3);

    return (
        <div className='activity-feed'>
            {displayedKeys.map((key, index) => {
                // Since the list is now reversed, the 'Latest Update' is simply the first item.
                const isLatestUpdate = index === 0;
                const date = activityFeedComments[key].datestamp;

                return (
                    <div
                        className={`activity-feed-notification ${isLatestUpdate ? 'latest-update' : ''}`}
                        key={`activity-feed-notification-${key}-${index}`}
                    >
                        {isLatestUpdate
                            ? (
                                <div className='latest-update-text'>
                                Latest Update <span className='latest-update-date'>{getDateDisplayString(date)}</span>
                                </div>
                            )
                            : (
                                <div className='notification-date'>{getDateDisplayString(date)}</div>
                            )}
                        <div className='notification-title'><Markdown>{activityFeedComments[key].title}</Markdown></div>
                        <div className='notification-comment'><Markdown>{activityFeedComments[key].comment}</Markdown></div>
                    </div>
                );
            })}

            {keys.length > 3 && !isExpanded && (
                <button onClick={() => setIsExpanded(true)} className='text-link subtle-link'>
                    Show more updates
                </button>
            )}
        </div>
    );
};

DesignatedFundLandingActivityFeed.propTypes = {
    keys: PropTypes.array.isRequired,
    activityFeedComments: PropTypes.object.isRequired,
};

DesignatedFundLandingActivityFeed = React.memo(DesignatedFundLandingActivityFeed);
